import React, { useState } from "react";

const BookmarkletGenerator: React.FC = () => {
  // State to hold the generated bookmarklet code
  const [bookmarkletCode, setBookmarkletCode] = useState<string>("");

  // Function to generate the bookmarklet
  const generateBookmarklet = (): void => {
    // Example: A bookmarklet that opens the current page in a modal
    const jsCode: string = `javascript:(function(){document.querySelector('select[id="natu"], select[name="natu"]').value='2';})();javascript:(function(){camb_naturalezalocal();})();
    javascript:(function(){setTimeout(function(){document.querySelector('select[id="naturaleza_tipo"], select[name="naturaleza_tipo"]').value='20';}, 500);})();
javascript:(function(){document.querySelector('textarea[id="naturaleza_detalle"], textarea[name="naturaleza_detalle"]').value='prueba';})();`;
    setBookmarkletCode(jsCode);
  };

  return (
    <div>
      <h1>Generate Your Bookmarklet</h1>
      <p>
        Click the button below to generate a bookmarklet that you can save to
        your bookmarks bar.
      </p>

      {/* Button to generate bookmarklet */}
      <button onClick={generateBookmarklet}>Generate Bookmarklet</button>

      {bookmarkletCode && (
        <div>
          <p>Drag the link below to your bookmarks bar:</p>
          <a
            href={bookmarkletCode}
            className="bookmarklet-link"
            title="Bookmarklet"
          >
            <strong>Bookmarklet Link</strong>
          </a>
        </div>
      )}
    </div>
  );
};

export default BookmarkletGenerator;
